import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response } from '@ui/src';
import { ProfitLoss, ProfitLossFrs } from '../../types';
import { profitLossApi } from '../services';

export interface ProfitLossFrsState {
  values?: ProfitLossFrs;
  vatPercent?: string;
}

const initialState: ProfitLossFrsState = {
  values: undefined,
};

export const ProfitLossFrsSlice = createSlice({
  name: 'profitLossFrs',
  initialState,
  reducers: {
    clearProfitLossFrsState: (state) => {
      state.values = undefined;
    },
    setReportsSettings: (
      state,
      action: PayloadAction<{ key: string; data: { value: string } }[]>,
    ) => {
      const vatPercent = action?.payload?.find(
        (item) => item.key === 'VAT-PERCENT',
      );

      if (vatPercent) {
        state.vatPercent = vatPercent?.data?.value;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      profitLossApi.endpoints.getProfitLossReport.matchFulfilled,
      (
        state,
        action: PayloadAction<{ data: ProfitLoss }> & {
          meta: { fulfilledTimeStamp: number };
        },
      ) => {
        const { profitLossFRS } = action.payload.data;

        state.values = profitLossFRS;
      },
    );
    builder.addMatcher(
      profitLossApi.endpoints.getReportsSettings.matchFulfilled,
      (
        state,
        action: PayloadAction<
          Response<{ key: string; data: { value: string } }>
        >,
      ) => {
        const vatPercent = action?.payload?.data?.edges?.find(
          (item) => item.node.key === 'VAT-PERCENT',
        );

        if (vatPercent) {
          state.vatPercent = vatPercent?.node?.data?.value;
        }
      },
    );
  },
});

export const { clearProfitLossFrsState, setReportsSettings } =
  ProfitLossFrsSlice.actions;

export default ProfitLossFrsSlice.reducer;
